// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"0a765944","194":"f3c66f57","216":"5d46bf8c","274":"768c0503","434":"900bedad","494":"6ae9fb72","555":"7d848854","677":"bc65c512","773":"6a3c68c3","888":"05265323","925":"31bd92c2","986":"96c3dda0"}[chunkId] + ".chunk.js";
};